import { CommonFilterParams, Filter, FilterOperators, FilterTypes } from '@va/types/filters';
import { AutocompleteOptionsFetcher } from '@va/ui/design-system';
import { HTMLInputTypeAttribute } from 'react';
import { TextFilterInput } from './TextFilterInput';
import { TextFilterInputApplied } from './TextFilterInputApplied';

export type TextFilterValue = number | string;
type PlaceholderFunc = (operator: FilterOperators) => string;

type TextFilterInputProps = {
  placeholder?: string | PlaceholderFunc;
  label?: string;
  type?: HTMLInputTypeAttribute;
  className?: string;
};

type TextFilterParams = {
  allowMultiSelect?: boolean;
  /**
   * Allows displaying infinite autocomplete options fetched from server
   */
  autocompleteOptionsFetcher?: AutocompleteOptionsFetcher;
  multiSelectButtonLabel?: string;
} & CommonFilterParams<TextFilterValue, TextFilterInputProps>;

export class TextFilter extends Filter<TextFilterValue, TextFilterInputProps> {
  autocompleteOptionsFetcher?: AutocompleteOptionsFetcher;
  multiSelectButtonLabel?: string;

  constructor(params: TextFilterParams) {
    super({
      ...params,
      operator: params.operator || FilterOperators.contains,
      input: TextFilterInput,
      appliedInput: TextFilterInputApplied,
      multipleValuesAllowed: params.allowMultiSelect || false,
      type: FilterTypes.Text,
    });

    this.autocompleteOptionsFetcher = params.autocompleteOptionsFetcher;
    this.multiSelectButtonLabel = params.multiSelectButtonLabel;
  }
}
